import type { ReservaCartao } from "@atlas/types";

/** Abaixo de um centavo nao ha margem — o mesmo piso da API (`MARGEM_MINIMA`). */
export const MARGEM_MINIMA = 0.01;

/** Fracao de centavo vira zero: e' o que a API recusa, e o card tem de concordar. */
export function disponivelUtil(disponivel: number): number {
  return Number.isFinite(disponivel) && disponivel >= MARGEM_MINIMA ? disponivel : 0;
}

interface MargemDaFicha {
  tipo: string;
  total: number;
  utilizado: number;
  disponivel: number;
}

/**
 * A ficha como fica depois da reserva, SEM esperar a recarga (15/10/2026).
 *
 * A rota da ficha leva de 8 a 16 s em homologacao, e a tela mostrava o card
 * antigo — "Reservar →" com a margem livre — o tempo todo. A resposta da
 * reserva ja' traz a reserva pronta: com ela o balde zera e o card vira
 * "Lançar →" na hora. A recarga completa continua, e o que ela trouxer vale.
 */
export function aplicarReservaNaFicha<F extends { margens?: MargemDaFicha[]; reservasCartao?: ReservaCartao[] }>(
  ficha: F,
  reserva: ReservaCartao,
): F {
  return {
    ...ficha,
    margens: ficha.margens?.map((m) =>
      m.tipo === reserva.produto
        ? {
            ...m,
            utilizado: Math.round((m.utilizado + reserva.valorReservado) * 100) / 100,
            disponivel: disponivelUtil(m.disponivel - reserva.valorReservado),
          }
        : m,
    ),
    reservasCartao: [...(ficha.reservasCartao ?? []).filter((r) => r.adf !== reserva.adf), reserva],
  };
}
